export type CatalogChild = {
  slug: string;
  label: string;
  keywords: string[];
  skuPrefixes?: string[];
};

export type CatalogParent = {
  slug: string;
  label: string;
  keywords: string[];
  children: CatalogChild[];
};

function normalize(value: string) {
  return String(value || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/đ/g, 'd');
}

export const catalogTaxonomy: CatalogParent[] = [
  {
    slug: 'pc-gaming',
    label: 'PC Gaming',
    keywords: ['pc gaming', 'pc ai', 'pc do hoa', 'mini pc'],
    children: [
      { slug: 'pc-gaming', label: 'PC Gaming', keywords: ['pc gaming'] },
      { slug: 'pc-do-hoa', label: 'PC Đồ Hoạ', keywords: ['pc do hoa', 'do hoa'] },
      { slug: 'pc-ai', label: 'PC AI', keywords: ['pc ai'] },
      { slug: 'mini-pc', label: 'Mini PC', keywords: ['mini pc'] },
    ],
  },
  {
    slug: 'pc-van-phong',
    label: 'PC văn phòng',
    keywords: ['pc van phong', 'pc doanh nghiep', 'mini pc'],
    children: [
      { slug: 'pc-van-phong', label: 'PC văn phòng', keywords: ['pc van phong'] },
      { slug: 'pc-doanh-nghiep', label: 'PC doanh nghiệp', keywords: ['pc doanh nghiep'] },
      { slug: 'mini-pc', label: 'Mini PC', keywords: ['mini pc'] },
    ],
  },
  {
    slug: 'cpu-mainboard-vga',
    label: 'CPU, Mainboard, VGA',
    keywords: ['cpu', 'mainboard', 'motherboard', 'vga', 'gpu', 'card man hinh'],
    children: [
      {
        slug: 'cpu-intel',
        label: 'CPU Intel',
        keywords: ['cpu intel', 'intel core', 'core i'],
        skuPrefixes: ['I3.', 'I5.', 'I7.', 'I9.', 'IU3.', 'IU5.', 'IU7.', 'IU9.'],
      },
      {
        slug: 'cpu-amd',
        label: 'CPU AMD',
        keywords: ['cpu amd', 'ryzen'],
        skuPrefixes: ['A.'],
      },
      {
        slug: 'mainboard-intel',
        label: 'Mainboard Intel',
        keywords: ['mainboard intel', 'z790', 'b760', 'h610'],
      },
      {
        slug: 'mainboard-amd',
        label: 'Mainboard AMD',
        keywords: ['mainboard amd', 'x670', 'b650', 'a620'],
      },
      {
        slug: 'vga-nvidia',
        label: 'VGA NVIDIA',
        keywords: ['vga nvidia', 'geforce', 'rtx', 'gtx'],
        skuPrefixes: ['V.'],
      },
      {
        slug: 'vga-amd',
        label: 'VGA AMD',
        keywords: ['vga amd', 'radeon', 'rx '],
        skuPrefixes: ['V.RX'],
      },
    ],
  },
  {
    slug: 'ram-ssd-hdd',
    label: 'RAM, SSD, HDD',
    keywords: ['ram', 'ssd', 'hdd', 'o cung'],
    children: [
      { slug: 'ram-ddr4', label: 'RAM DDR4', keywords: ['ram ddr4', 'ddr4'] },
      { slug: 'ram-ddr5', label: 'RAM DDR5', keywords: ['ram ddr5', 'ddr5'] },
      {
        slug: 'ssd-nvme',
        label: 'SSD NVMe',
        keywords: ['ssd nvme', 'nvme'],
        skuPrefixes: ['SS.'],
      },
      {
        slug: 'ssd-sata',
        label: 'SSD SATA',
        keywords: ['ssd sata', 'sata ssd'],
        skuPrefixes: ['SS.'],
      },
      { slug: 'hdd', label: 'HDD', keywords: ['hdd', 'hard disk'], skuPrefixes: ['H.'] },
    ],
  },
  {
    slug: 'laptop',
    label: 'Laptop',
    keywords: ['laptop', 'notebook'],
    children: [
      { slug: 'laptop-gaming', label: 'Laptop Gaming', keywords: ['laptop gaming'] },
      { slug: 'laptop-van-phong', label: 'Laptop Văn phòng', keywords: ['laptop van phong'] },
      { slug: 'laptop-ai', label: 'Laptop AI', keywords: ['laptop ai'] },
    ],
  },
  {
    slug: 'man-hinh',
    label: 'Màn hình',
    keywords: ['man hinh', 'monitor'],
    children: [],
  },
  {
    slug: 'case-tan-nguon',
    label: 'Case, Tản, Nguồn',
    keywords: ['case', 'tan nhiet', 'nguon', 'psu'],
    children: [
      { slug: 'case-gaming', label: 'Case Gaming', keywords: ['case gaming'] },
      { slug: 'case-van-phong', label: 'Case Văn phòng', keywords: ['case van phong'] },
      { slug: 'tan-nhiet', label: 'Tản nhiệt', keywords: ['tan nhiet', 'cooler'] },
      { slug: 'nguon-may-tinh', label: 'Nguồn máy tính', keywords: ['nguon may tinh', 'psu'] },
    ],
  },
  {
    slug: 'phim-chuot-tai-nghe',
    label: 'Phím, chuột, tai nghe',
    keywords: ['ban phim', 'chuot', 'tai nghe', 'keyboard', 'mouse', 'headset'],
    children: [
      {
        slug: 'ban-phim',
        label: 'Bàn phím',
        keywords: ['ban phim', 'keyboard'],
        skuPrefixes: ['KB.'],
      },
      { slug: 'chuot', label: 'Chuột', keywords: ['chuot', 'mouse'] },
      { slug: 'tai-nghe', label: 'Tai nghe', keywords: ['tai nghe', 'headset'] },
    ],
  },
  {
    slug: 'ban-ghe',
    label: 'Bàn, ghế',
    keywords: ['ban', 'ghe', 'gaming desk', 'gaming chair'],
    children: [
      { slug: 'ghe-gaming', label: 'Ghế Gaming', keywords: ['ghe gaming', 'gaming chair'] },
      {
        slug: 'ghe-cong-thai-hoc',
        label: 'Ghế Công thái học',
        keywords: ['cong thai hoc', 'ergonomic chair'],
      },
      { slug: 'ban-gaming', label: 'Bàn Gaming', keywords: ['ban gaming', 'gaming desk'] },
    ],
  },
  {
    slug: 'thiet-bi-mang',
    label: 'Thiết bị mạng',
    keywords: ['router', 'switch', 'wifi', 'thiet bi mang', 'usb wifi'],
    children: [
      { slug: 'router-wifi', label: 'Router WiFi', keywords: ['router wifi', 'router'] },
      { slug: 'switch', label: 'Switch', keywords: ['switch'] },
      { slug: 'usb-wifi', label: 'USB WiFi', keywords: ['usb wifi'] },
    ],
  },
  {
    slug: 'may-in-ups',
    label: 'Máy in, UPS',
    keywords: ['may in', 'printer', 'ups'],
    children: [
      { slug: 'may-in-mau', label: 'Máy in màu', keywords: ['may in mau', 'color printer'] },
      {
        slug: 'may-in-den-trang',
        label: 'Máy in đen trắng',
        keywords: ['may in den trang', 'laser printer'],
      },
      { slug: 'ups', label: 'UPS', keywords: ['ups'] },
    ],
  },
  {
    slug: 'camera-webcam',
    label: 'Camera, webcam',
    keywords: ['camera', 'webcam'],
    children: [
      { slug: 'camera-trong-nha', label: 'Camera trong nhà', keywords: ['camera trong nha'] },
      { slug: 'camera-ngoai-troi', label: 'Camera ngoài trời', keywords: ['camera ngoai troi'] },
      { slug: 'webcam', label: 'Webcam', keywords: ['webcam'] },
    ],
  },
];

export function getCatalogParentBySlug(slug: string) {
  return catalogTaxonomy.find((item) => item.slug === slug) || null;
}

export function detectChildSlugs(parentSlug: string, textSources: string[]) {
  const parent = getCatalogParentBySlug(parentSlug);
  if (!parent) return [] as string[];
  const haystack = normalize(textSources.filter(Boolean).join(' '));
  return parent.children
    .filter((child) => child.keywords.some((keyword) => haystack.includes(normalize(keyword))))
    .map((child) => child.slug);
}

export function detectTaxonomyTags(textSources: string[]) {
  const haystack = normalize(textSources.filter(Boolean).join(' '));
  const parentSlugs: string[] = [];
  const childSlugs: string[] = [];

  for (const parent of catalogTaxonomy) {
    const parentMatched = parent.keywords.some((keyword) => haystack.includes(normalize(keyword)));
    if (!parentMatched) continue;
    parentSlugs.push(parent.slug);
    for (const child of parent.children) {
      const childMatched = child.keywords.some((keyword) => haystack.includes(normalize(keyword)));
      if (childMatched) childSlugs.push(child.slug);
    }
  }

  return {
    parentSlugs: Array.from(new Set(parentSlugs)),
    childSlugs: Array.from(new Set(childSlugs)),
  };
}
